import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCatalog } from '../context/CatalogContext';
import axios from 'axios';
import { AthleteProfileShell } from '../components/ProfileShell';
import TrackMarksEditor from '../components/athleteEditor/TrackMarksEditor';
import EquestrianResultsEditor from '../components/athleteEditor/EquestrianResultsEditor';
import ResultEntriesEditor from '../components/athleteEditor/ResultEntriesEditor';
import MatchRecordEditor from '../components/athleteEditor/MatchRecordEditor';
import SeasonStatsEditor from '../components/athleteEditor/SeasonStatsEditor';

export default function GameStatsPage() {
  const { API_URL } = useAuth();
  const catalog = useCatalog();
  const [sportName, setSportName] = useState('Football');
  const [positions, setPositions] = useState([]);

  const getAxiosConfig = () => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${API_URL}/athletes/profile`, getAxiosConfig());
      if (response.data) {
        const d = response.data;
        setSportName(d.sport || 'Football');
        setPositions([d.position_primary, d.position_secondary, d.position_other].filter(Boolean));
      }
    } catch (error) {
      console.log('Error fetching profile:', error);
    }
  };

  // Which ledger an athlete keeps is a property of their sport. Track is
  // event-based and equestrian keeps an NCEA/IHSA show record — neither fits
  // the position/year stat grid — and the Wave-2 sports route off the
  // catalog's stats_mode. Same routing as iOS's ProfileSectionDestination and
  // the admin edit panel's Stats section.
  const sportSlug = catalog.sportSlugFor(sportName);
  const statsMode = catalog.statsModeFor(sportSlug);

  const editor =
    sportSlug === 'track' ? <TrackMarksEditor />
    : sportSlug === 'equestrian' ? <EquestrianResultsEditor />
    : statsMode === 'result_entries' ? <ResultEntriesEditor sportSlug={sportSlug} />
    : statsMode === 'match_record' ? <MatchRecordEditor sportSlug={sportSlug} />
    : <SeasonStatsEditor sportSlug={sportSlug} positions={positions} />;

  return <AthleteProfileShell activeTab="Stats">{editor}</AthleteProfileShell>;
}
